import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ThumbsDownSvg = function ThumbsDownSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 7.828v5.828h3.72l1.112 4.172L7.943 22l.9-.012c.931-.013 1.042-.023 1.443-.132 1.35-.367 2.442-1.516 2.783-2.929.11-.455.116-.557.116-2.02v-1.38h4.413c3.52 0 4.41-.005 4.402-.03l-2.292-6.763L17.427 2H2zm1.432.012v4.347h2.114V3.493H3.432zm3.547.314v4.662l1.012 3.802 1.025 3.843c.01.036.043.042.258.042.645 0 1.243-.246 1.704-.7.445-.437.712-1 .773-1.633.015-.164.024-.963.024-2.196v-1.939h4.104c2.257 0 4.103-.008 4.102-.018s-.802-2.379-1.78-5.265l-1.779-5.248-4.721-.006-4.722-.006z",
    clipRule: "evenodd"
  }));
};
export var ThumbsDown = function ThumbsDown(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ThumbsDownSvg
  }));
};